import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModalComponent } from './modal/modal.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';
import { ModalAddUsersComponent } from './modal-addusers/modal-addusers.component';
import { NgSelect2Module } from 'ng-select2';
import { MatChipsModule } from '@angular/material/chips';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatIconModule } from '@angular/material/icon';
import { ToastrModule } from 'ngx-toastr';
import { CustomToastComponent } from './custom-toast/custom-toast.component';

import { GoogleMapsModule } from '@angular/google-maps';
import { GoogleMapsComponent } from './google-maps/google-maps.component';
import { GoogleMapsPickerComponent } from './google-maps-picker/google-maps-picker.component';
import { CodeViewerComponent } from './code-viewer/code-viewer.component';
import { SidebarDocumentationComponent } from './sidebar-documentation/sidebar-documentation.component';
import { EditorComponent } from './editor/editor.component';
import { DynamicformFieldComponent } from './dynamic-form-field/dynamic-form-field.component';
import { LineChartComponent } from './line-chart/line-chart.component';
import { NgChartsModule } from 'ng2-charts';
import { ModalAddUsersOrganizationComponent } from './modal-addusers-organization/modal-addusers-organization.component';
import { ModalAddTradeAgreementComponent } from './modal-add-trade-agreement/modal-add-trade-agreement.component';
import { ModalViewTradeAgreementComponent } from './modal-view-trade-agreement/modal-view-trade-agreement.component';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { ModalMessageComponent } from './modal-message/modal-message.component';
import { ModalRequestApprovementComponent } from './modal-request-approvement/modal-request-approvement.component';
import { CustomTableComponent } from './custom-table/custom-table.component';
import { CustomTableMinComponent } from './custom-table-min/custom-table-min.component';
import { ModalViewPaymentComponent } from './modal-view-payment/modal-view-payment.component';
import { ModalViewProductComponent } from './modal-view-product/modal-view-product.component';
import { ModalViewObjectiveComponent } from './modal-view-objective/modal-view-objective.component';
import { ModalViewChargeComponent } from './modal-view-charge/modal-view-charge.component';
import { ModalViewUserComponent } from './modal-view-user/modal-view-user.component';
import { MatSelectModule } from '@angular/material/select';
import { ModalViewRoleComponent } from './modal-view-role/modal-view-role.component';
import { ModalViewAssetLocationComponent } from './modal-view-asset-location/modal-view-asset-location.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { CdkAccordionModule } from '@angular/cdk/accordion';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { ModalViewBranchOffice } from './modal-view-branch-office/modal-view-branch-office.component';
import { ModalUserInformationComponent } from './modal-user-information/modal-user-information.component';
import { ModalViewTradeAgreementComponent2 } from './modal-view-trade-agreement2/modal-view-trade-agreement2.component';
import { ModalMassiveChargeComponent } from './modal-massive-charge/modal-massive-charge.component';

import { ModalArrivedDataComponent } from './modal-arrived-data/modal-arrived-data.component';
import { ModalManualDebtComponent } from './modal-manual-debt/modal-manual-debt.component';
import { InventoryTabsComponent } from './inventory-tabs/inventory-tabs.component';
import { ModalReturnAssetComponent } from './modal-return-asset/modal-return-asset.component';
import { ModalAssetHistoryComponent } from './modal-asset-history/modal-asset-history.component';
import { DocumentValidationStatusComponent } from './document-validation-status/document-validation-status.component';

@NgModule({
  declarations: [
    ModalComponent,
    ModalAddUsersComponent,
    ModalAddUsersOrganizationComponent,
    CustomToastComponent,
    GoogleMapsComponent,
    GoogleMapsPickerComponent,
    CodeViewerComponent,
    SidebarDocumentationComponent,
    EditorComponent,
    DynamicformFieldComponent,
    LineChartComponent,
    ModalAddTradeAgreementComponent,
    ModalViewTradeAgreementComponent,
    ModalViewTradeAgreementComponent2,
    ModalMessageComponent,
    ModalRequestApprovementComponent,
    CustomTableComponent,
    CustomTableMinComponent,
    ModalViewPaymentComponent,
    ModalViewProductComponent,
    ModalViewObjectiveComponent,
    ModalViewChargeComponent,
    ModalViewUserComponent,
    ModalViewRoleComponent,
    ModalViewBranchOffice,
    ModalUserInformationComponent,
    ModalViewObjectiveComponent,
    ModalArrivedDataComponent,
    ModalMassiveChargeComponent,
    ModalManualDebtComponent,
    InventoryTabsComponent,
    ModalViewAssetLocationComponent,
    ModalReturnAssetComponent,
    ModalAssetHistoryComponent,
    DocumentValidationStatusComponent
  ],
  imports: [
    NgChartsModule,
    GoogleMapsModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatInputModule,
    MatFormFieldModule,
    MatButtonModule,
    RouterModule,
    NgSelect2Module,
    MatChipsModule,
    MatAutocompleteModule,
    MatIconModule,
    ToastrModule.forRoot({
      toastComponent: CustomToastComponent,
      newestOnTop: false,
      preventDuplicates: true
    }),
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatSelectModule,
    CdkAccordionModule,
    MatSlideToggleModule,
    Ng2SearchPipeModule,
    CommonModule
  ],
  entryComponents: [CustomToastComponent],
  exports: [
    ModalComponent,
    ModalAddUsersComponent,
    ModalAddUsersOrganizationComponent,
    CustomToastComponent,
    GoogleMapsComponent,
    GoogleMapsPickerComponent,
    CodeViewerComponent,
    SidebarDocumentationComponent,
    EditorComponent,
    DynamicformFieldComponent,
    LineChartComponent,
    CustomTableMinComponent,
    CustomTableComponent,
    ModalViewObjectiveComponent,
    ModalArrivedDataComponent,
    InventoryTabsComponent,
    DocumentValidationStatusComponent
  ]
})
export class ComponentsModule { }
